<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" offset-md="3" class="white elevation-4">
        <h1 class="text-center headline mb-6">Log In to LifeWith™</h1>
        <v-form>
          <v-text-field
            type="email"
            v-model="email"
            label="E-mail"
            required
          ></v-text-field>
          <v-text-field
            type="password"
            v-model="password"
            label="Password"
            required
          ></v-text-field>
          <p class="body text-center">
            Forgot your password?
            <router-link to="password-reset">Recover Password</router-link>
          </p>
          <v-btn block rounded dark color="orange" class="mt-6" @click="submit">
            <span v-if="!loading">Log In</span>
            <v-progress-circular
              indeterminate
              color="white"
              v-if="loading"
            ></v-progress-circular>
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      loading: false,
      password: null,
      snackbar: {
        show: false,
        text: "",
      },
    };
  },
  methods: {
    ...mapActions({
      login: "users/login",
    }),
    async submit() {
      if (!this.email || !this.password) {
        this.snackbar = {
          show: true,
          text: "Please complete all fields",
        };
        return;
      }

      this.loading = true;

      try {
        await this.login({
          email: this.email,
          password: this.password,
        });
        window.location = "/profiles";
      } catch (err) {
        this.snackbar = {
          show: true,
          text: err.message,
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 10%;
}
</style>
